import { render, staticRenderFns } from "./MultipleForm.vue?vue&type=template&id=628af40f&scoped=true"
import script from "./MultipleForm.vue?vue&type=script&lang=js"
export * from "./MultipleForm.vue?vue&type=script&lang=js"
import style0 from "./MultipleForm.vue?vue&type=style&index=0&id=628af40f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628af40f",
  null
  
)

export default component.exports